import React, { useEffect, useState } from 'react';
import MemberCard from '../components/MemberCard';
import Spinner from '../components/Spinner';
import '../styles/MembersPage.css';

function MembersPage() {
  const [members, setMembers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Fetch members data from public directory
    fetch('/data/members.json')
      .then(response => {
        if (!response.ok) {
          throw new Error("Failed to fetch members.json");
        }
        return response.json();
      })
      .then(data => {
        // Update members and set loading to false
        setMembers(data);
        setIsLoading(false);
      })
      .catch(error => {
        console.error("Error fetching members.json:", error);
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div className="members-page">
      <h1>Members</h1>
      <div className="members-grid">
        {members.map((member) => (
          <MemberCard
            id={member.id}
            profilePic={`/data/${member.personal_folder}/pfp.jpg`}
            name={member.name}
            position={member.position}
            specializations={member.specializations}
            profileUrl={member.url} // Pass the profile URL
          />
        ))}
      </div>
    </div>
  );
}

export default MembersPage;
